import React from "react";
import styles from "./Footer.module.css";
import logo from "../assets/Logo.svg";
const Footer = ({ languages }) => {
  return (
    <footer>
      <div className={styles["footer_container"]}>
        <div className={styles["logo"]}>
          <img src={logo} alt="logo" />
          <div>
            Linked<span>In</span>{" "}
          </div>
        </div>
        <div className={styles["navigation"]}>
          <div className={styles["title"]}>Navigation</div>
          <div className={styles["navigation_bottom"]}>
            <div className={styles["navigation_link-container"]}>
              <a href="#">About</a>
              <a href="#">Careers</a>
              <a href="#">Advertising</a>
              <a href="#">Small Bussiness</a>
            </div>
            <div className={styles["navigation_link-container"]}>
              <a href="#">Talent Solutions</a>
              <a href="#">Marketing Solutions</a>
              <a href="#">Sales Solutions</a>
              <a href="#">Safery Center</a>
            </div>
            <div className={styles["navigation_link-container"]}>
              <a href="#">Community Guidelines</a>
              <a href="#">Privacy & Terms</a>
              <a href="#">Mobile App</a>
            </div>
          </div>
        </div>
        <div className={styles["fast_access"]}>
          <div className={styles["title"]}>Fast access</div>
          <div className={styles["buttons"]}>
            <button className={styles["main-button"]}>
              <span>Questions?</span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.99998 14.6666C11.6819 14.6666 14.6666 11.6818 14.6666 7.99992C14.6666 4.31802 11.6819 1.33325 7.99998 1.33325C4.31808 1.33325 1.33331 4.31802 1.33331 7.99992C1.33331 11.6818 4.31808 14.6666 7.99998 14.6666Z"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.06006 5.99989C6.21679 5.55434 6.52616 5.17863 6.93336 4.93931C7.34056 4.7 7.81932 4.61252 8.28484 4.69237C8.75036 4.77222 9.1726 5.01424 9.47678 5.37558C9.78095 5.73691 9.94743 6.19424 9.94672 6.66656C9.94672 7.99989 7.94672 8.66656 7.94672 8.66656"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8 11.3333H8.00667"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button className={styles["side-button"]}>
              <span>Settings</span>
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.512 10.1519C13.4232 10.353 13.3968 10.5761 13.436 10.7923C13.4752 11.0086 13.5783 11.2081 13.732 11.3653L13.772 11.4053C13.8959 11.5291 13.9943 11.6762 14.0614 11.838C14.1285 11.9999 14.163 12.1734 14.163 12.3486C14.163 12.5238 14.1285 12.6973 14.0614 12.8592C13.9943 13.0211 13.8959 13.1681 13.772 13.2919C13.6481 13.4159 13.5011 13.5142 13.3392 13.5813C13.1774 13.6484 13.0039 13.683 12.8286 13.683C12.6534 13.683 12.4799 13.6484 12.318 13.5813C12.1562 13.5142 12.0091 13.4159 11.8853 13.2919L11.8453 13.2519C11.6882 13.0982 11.4886 12.9951 11.2724 12.9559C11.0561 12.9167 10.833 12.9432 10.632 13.0319C10.4348 13.1164 10.2666 13.2568 10.1482 13.4356C10.0297 13.6145 9.96616 13.8241 9.9653 14.0386V14.1519C9.9653 14.5056 9.82482 14.8447 9.57478 15.0947C9.32473 15.3448 8.98559 15.4853 8.63197 15.4853C8.27834 15.4853 7.93921 15.3448 7.68916 15.0947C7.43911 14.8447 7.29863 14.5056 7.29863 14.1519V14.0919C7.29347 13.8713 7.22205 13.6573 7.09364 13.4777C6.96524 13.2982 6.78579 13.1615 6.57863 13.0853C6.37756 12.9965 6.1545 12.9701 5.93824 13.0093C5.72198 13.0485 5.52242 13.1516 5.3653 13.3053L5.3253 13.3453C5.20147 13.4692 5.05442 13.5676 4.89255 13.6347C4.73069 13.7018 4.55719 13.7363 4.38197 13.7363C4.20675 13.7363 4.03324 13.7018 3.87138 13.6347C3.70952 13.5676 3.56246 13.4692 3.43863 13.3453C3.31466 13.2214 3.21632 13.0744 3.14922 12.9125C3.08212 12.7507 3.04758 12.5772 3.04758 12.4019C3.04758 12.2267 3.08212 12.0532 3.14922 11.8913C3.21632 11.7295 3.31466 11.5824 3.43863 11.4586L3.47863 11.4186C3.63232 11.2615 3.73542 11.0619 3.77464 10.8457C3.81385 10.6294 3.78738 10.4063 3.69863 10.2053C3.61412 10.0081 3.4738 9.83992 3.29494 9.72147C3.11608 9.60302 2.90649 9.53946 2.69197 9.5386H2.57863C2.22501 9.5386 1.88587 9.39813 1.63582 9.14808C1.38578 8.89803 1.2453 8.55889 1.2453 8.20527C1.2453 7.85165 1.38578 7.51251 1.63582 7.26246C1.88587 7.01241 2.22501 6.87194 2.57863 6.87194H2.63863C2.8593 6.86677 3.0733 6.79535 3.25283 6.66694C3.43236 6.53854 3.56911 6.35909 3.6453 6.15194C3.73404 5.95086 3.76052 5.72781 3.7213 5.51154C3.68209 5.29528 3.57899 5.09572 3.4253 4.9386L3.3853 4.8986C3.26133 4.77477 3.16299 4.62772 3.09589 4.46586C3.02879 4.30399 2.99425 4.13049 2.99425 3.95527C2.99425 3.78005 3.02879 3.60655 3.09589 3.44468C3.16299 3.28282 3.26133 3.13577 3.3853 3.01194C3.50913 2.88797 3.65618 2.78962 3.81805 2.72252C3.97991 2.65542 4.15341 2.62089 4.32863 2.62089C4.50385 2.62089 4.67736 2.65542 4.83922 2.72252C5.00108 2.78962 5.14814 2.88797 5.27197 3.01194L5.31197 3.05194C5.46909 3.20563 5.66864 3.30873 5.88491 3.34794C6.10117 3.38715 6.32422 3.36068 6.5253 3.27194H6.57863C6.77581 3.18743 6.94398 3.04711 7.06243 2.86825C7.18088 2.68939 7.24444 2.47979 7.2453 2.26527V2.15194C7.2453 1.79831 7.38578 1.45918 7.63582 1.20913C7.88587 0.959079 8.22501 0.818604 8.57863 0.818604C8.93226 0.818604 9.27139 0.959079 9.52144 1.20913C9.77149 1.45918 9.91197 1.79831 9.91197 2.15194V2.21194C9.91282 2.42646 9.97639 2.63605 10.0948 2.81491C10.2133 2.99377 10.3815 3.13409 10.5786 3.2186C10.7797 3.30735 11.0028 3.33382 11.219 3.29461C11.4353 3.25539 11.6348 3.15229 11.792 2.9986L11.832 2.9586C11.9558 2.83463 12.1028 2.73629 12.2647 2.66919C12.4266 2.60209 12.6001 2.56755 12.7753 2.56755C12.9505 2.56755 13.124 2.60209 13.2859 2.66919C13.4478 2.73629 13.5948 2.83463 13.7186 2.9586C13.8426 3.08243 13.9409 3.22949 14.008 3.39135C14.0751 3.55321 14.1097 3.72672 14.1097 3.90194C14.1097 4.07716 14.0751 4.25066 14.008 4.41252C13.9409 4.57439 13.8426 4.72144 13.7186 4.84527L13.6786 4.88527C13.5249 5.04239 13.4218 5.24195 13.3826 5.45821C13.3434 5.67447 13.3699 5.89753 13.4586 6.0986V6.15194C13.5431 6.34912 13.6835 6.51728 13.8623 6.63573C14.0412 6.75418 14.2508 6.81775 14.4653 6.8186H14.5786C14.9323 6.8186 15.2714 6.95908 15.5214 7.20913C15.7715 7.45918 15.912 7.79831 15.912 8.15194C15.912 8.50556 15.7715 8.8447 15.5214 9.09475C15.2714 9.34479 14.9323 9.48527 14.5786 9.48527H14.5186C14.3041 9.48613 14.0945 9.54969 13.9157 9.66814C13.7368 9.78659 13.5965 9.95476 13.512 10.1519V10.1519Z"
                  stroke="#0275B1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className={styles["language"]}>
          <div className={styles["title"]}>Language</div>
          <select name="language" id="language">
            {languages.map((language, i) => {
              return (
                <option value={language} key={`${language}_Language`}>
                  {language}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
